import {Component} from '@angular/core';
import {
    BasicEntityTableColumnDescriptionOrString,
    ColumnJustification
} from "../../../basic-entity-front/basic-entity-table/basic-entity-table.component";
import {Cliente} from "../../../model/personas/cliente.model";
import {ClientesEditionComponent} from "./clientes-edition/clientes-edition.component";
import {Pedido} from "../../../model/pedidos/pedido.model";
import {Usuario} from "../../../model/personas/usuario.model";
import {InterfaceProviderService} from "../../../basic-entity-back/services/interface-provider.service";
import {UsuarioService} from "../../../services/usuario.service";
import {BehaviorSubject} from "rxjs";
import {Incidencia} from "../../../model/incidencias/incidencia.model";
import {SimpleDialogService} from "../../../basic-entity-front/dialog-shell/simple-dialog.service";

@Component({
    selector: 'app-clientes',
    template: '<be-table [columnsToDisplay]="columns" [modelType]="model" [editionDialog]="dialog" [rowClass]="clase" [reloadDataSource]="reload" [actions]="actions" id="clientes"></be-table>',
    styles: [
        `::ng-deep.baja {
            background-color: rgba(248, 134, 134, 0.46) !important;
        }`
    ]
})

export class ClientesComponent {


    public readonly actions = [
        {
            text: 'Bloquear cliente',
            icono: 'lock',
            tooltip: 'Bloquear cliente',
            handler: this._activarCliente.bind(this),
            disabled: this._deshabilitarBloquear.bind(this),
        },
        {
            text: 'Activar cliente',
            icono: 'lock_open',
            tooltip: 'Activar cliente',
            handler: this._activarCliente.bind(this),
            disabled: this._deshabilitarDesbloquear.bind(this),
        }];

    public model = Cliente;
    public dialog = ClientesEditionComponent;
    public columns: BasicEntityTableColumnDescriptionOrString[] = [
        {key: 'id', hiddenDisplayable: true},
        // {key: 'codigo', weight: 1, hiddenInEdition: true},
        {key: 'baja', weight: 1},
        {key: 'empresa', weight: 1},
        {key: 'fechaAlta', weight: 2},
        {key: 'fechaCreacion', hidden: true, weight: 2},
        {key: 'fechaModificacion', hidden: true, weight: 2},
        {key: 'nombreCompletoCliente', hiddenInEdition: true, weight: 4},
        {key: 'nombre', hiddenDisplayable: true, weight: 2},
        {key: 'apellido1', hiddenDisplayable: true, weight: 2},
        {key: 'apellido2', hiddenDisplayable: true, weight: 2},
        {key: 'denominacionSocial', weight: 2},
        {key: 'cifNif', hiddenDisplayable: true, weight: 2},
        {key: 'email', weight: 4},
        {key: 'comercial', weight: 1},
        {key: 'idioma', weight: 1, justification: ColumnJustification.Center},
        {key: 'direccionEnvio', hiddenDisplayable: true},
        {key: 'direccionFacturacion', hiddenDisplayable: true},
        {key: 'telefonos', hiddenDisplayable: true},
        {key: 'descuentosMetodoFabricacion', hiddenDisplayable: true},
        {key: 'diaMesParaCargo', weight: 1, hidden: true},
        {key: 'facturaSimplificada', weight: 1, hidden: true},
        {key: 'formasPagoDisponibles', hidden: true, hiddenDisplayable: true},
        {key: 'cuentasBancariasCliente', hidden: true, hiddenDisplayable: true},
        {key: 'mandato', hidden: true, hiddenDisplayable: true},
        {key: 'descuentosGenerales', hidden: true},
        {key: 'prioridadEnvio', hidden: true},
        {
            key: 'activado',
            justification: ColumnJustification.Center,
            shownAsButton: true,
            buttonData: {
                text: this._getTextoActivado.bind(this),
                action: () => null,
                class: this._getClassActivado.bind(this),
                disabled: () => false
            },
            weight: 2
        },
    ];
    reload: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private _usuarioService: UsuarioService, private _simpleDialog: SimpleDialogService) {
    }

    public readonly clase = [
        {
            class: this._getClassRow.bind(this)
        }
    ];

    _getClassRow(cliente: Cliente) {
        if (cliente.baja) {
            return 'baja';
        }
    }

    _getTextoActivado(activado) {
        return activado ? 'Activado' : 'No Activado';
    }

    _getClassActivado(activado) {
        return activado ? 'activado' : 'no-activado';
    }

    _deshabilitarBloquear(cliente: Cliente) {
        return !cliente.activado;
    }

    _deshabilitarDesbloquear(cliente: Cliente) {
        return cliente.activado;
    }

    _activarCliente(cliente: Cliente) {
        if (cliente.activado) {
            this._simpleDialog.confirmationDialog('Bloquear cliente',
                `¿Seguro que desea bloquear el cliente <strong>${cliente.usuario.username}</strong>?`,
                ['Bloquear', 'check', 'warn'],
                'Cancelar',
                false,
                false,
                700
            )
                .then(ok => {
                    if (ok) {
                        this._usuarioService.bloquearCliente(cliente).subscribe(res => {
                            this.reload.next(true)
                        })
                    }
                });
        } else {
            this._simpleDialog.confirmationDialog('Activar cliente',
                `¿Seguro que desea activar el cliente <strong>${cliente.usuario.username}</strong>?`,
                ['Activar', 'check', 'primary'],
                'Cancelar',
                false,
                false,
                700
            )
                .then(ok => {
                    if (ok) {
                        this._usuarioService.activarCliente(cliente).subscribe(res => {
                            this.reload.next(true)
                        })
                    }
                });
        }
    }
}
